var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 187,
    viewBox: "0 0 187 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2680_7006)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2680_7006",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 19,
    width: 164,
    height: 158
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0864 19.6235H187V176.966H23.0864V19.6235Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2680_7006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.988 149.664V19.6821H23.3011V176.97H155.397L186.988 149.664Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2680_7006",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 19,
    width: 165,
    height: 158
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6975 19.6235H176.611V176.966H12.6975V19.6235Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2680_7006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.536 149.664V19.6821H12.849V176.97H144.945L176.536 149.664Z",
    fill: "#EEBA2D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2680_7006",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 62,
    height: 46
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0515H61.179V55.1764H0V10.0515Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2680_7006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0119629 35.7297L44.9457 10.0515L48.1544 16.4724L60.9926 22.8906L9.64062 54.9907L6.43197 45.3602L0.0119629 35.7297Z",
    fill: "#C14949"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2680_7006",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 147,
    width: 33,
    height: 30
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.29 147.984H176.611V176.966H144.29V147.984Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2680_7006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.443 148.079V176.97H144.945L176.536 149.664V148.079H144.443Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2680_7006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 187,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/Paper.7a536eaa0f20472d1573cfad3e937903.svg";
export { ForwardRef as ReactComponent };